import { TextField } from "@mui/material";
import InputMask from "react-input-mask";

export function cpfValidation(cpf: string): boolean {
  if (!cpf) return true;

  const cleanCpf = cpf.replace(/[^\d]/g, "");
  if (cleanCpf.length !== 11) return false;

  if (/^(\d)\1{10}$/.test(cleanCpf)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleanCpf.charAt(i)) * (10 - i);
  }
  let remainder = sum % 11;
  const digit1 = remainder < 2 ? 0 : 11 - remainder;

  if (parseInt(cleanCpf.charAt(9)) !== digit1) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleanCpf.charAt(i)) * (11 - i);
  }
  remainder = sum % 11;
  const digit2 = remainder < 2 ? 0 : 11 - remainder;

  if (parseInt(cleanCpf.charAt(10)) !== digit2) return false;

  return true;
}

interface CpfInputFieldProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  error?: boolean;
  helperText?: string;
  optional?: boolean;
}

export function CpfInputField({
  label,
  value,
  onChange,
  optional = false,
}: CpfInputFieldProps) {
  const isValid = optional || !value || cpfValidation(value);
  const isError = !isValid && value.length > 0;
  const showHelperText = isError;

  return (
    <InputMask
      mask="999.999.999-99"
      maskChar={null}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {
        ((inputProps: any) => (
          <TextField
            {...inputProps}
            fullWidth
            required={!optional}
            label={label}
            variant="outlined"
            error={isError}
            helperText={
              showHelperText ? "Formato de CPF inválido (XXX.XXX.XXX-XX)" : ""
            }
          />
        )) as unknown as React.ReactNode
      }
    </InputMask>
  );
}
